"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SCHED_RANGE_DAYS = void 0;
const SCHED_RANGE_DAYS = exports.SCHED_RANGE_DAYS = 14;